import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalOptimizationService } from '@app/modals/modal-optimization/modal-optimization.service';
import { takeWhile } from 'rxjs';
import * as _ from 'lodash';
import { OptimizationDao } from '@app/dao/optimization/optimization.dao';
import { log } from 'console';

@Component({
    selector: 'ea-optimisations',
    templateUrl: './ea-optimisations.component.html',
    styleUrls: ['./ea-optimisations.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EaOptimisationsComponent implements OnInit {
  optimisations: any[] = [];
  accordionOpened: boolean = false;
  alive: boolean = true;
  _ = _;
  constructor(
    private optimizationDao: OptimizationDao,
    private router: Router,
  ) {}

  ngOnInit() {
    this.optimizationDao.getOptimizationSummary().subscribe(optimizations => {
      this.optimisations = optimizations;
    });
  }

  openOptimization(optimization) {
    if (optimization.type == 'TAX')
      this.router.navigate([`/dashboard/taxes/overview`]);
    else
      this.router.navigate([
        `/dashboard/optimizations/${optimization.subjectId}`,
      ]);
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
